module.exports = __webpack_public_path__ + "/login_ui/img/sz-0e54f8072cc1d2369cbfe66f6bf5854c.svg";